import React from 'react';
import { MotifIcon, MotifIconButton } from '@ey-xd/motif-react';
import { IconoirEditPencil, IconoirTrash } from '@ey-xd/motif-icon';

export default (props) => {
  const getCurrentRowData = () => props.node?.data || props.data;

  const onEditClick = () => {
    if (props.handleEditButtonClick) {
      props.handleEditButtonClick(getCurrentRowData());
    }
  };

  const onDeleteClick = () => {
    if (props.handleDeleteButtonClick) {
      props.handleDeleteButtonClick(getCurrentRowData());
    }
  };

  return (
    <div>
      {props.column.colId === 'editactions' && (
        <span className="mt-2">
          <MotifIconButton
            aria-label="Edit this Group"
            type="button"
            onClick={onEditClick}
            data-testid="btnEditGroup"
          >
            <MotifIcon
              iconFunction={IconoirEditPencil}
              size="24"
              title="Edit this Group"
            />
          </MotifIconButton>
        </span>
      )}

      {props.column.colId === 'deleteactions' && (
        <span className="mt-2">
          <MotifIconButton
            aria-label="Delete this Group"
            type="button"
            onClick={onDeleteClick}
            data-testid="btnDeleteGroup"
          >
            <MotifIcon
              iconFunction={IconoirTrash}
              size="24"
              title="Delete this Group"
            />
          </MotifIconButton>
        </span>
      )}
    </div>
  );
};
